import { api } from "./configs/axiosConfigs";

export const LoginAPI = {
  login: async (login, password) => {
    const formData = new FormData();
    formData.append("username", login);
    formData.append("password", password);

    const response = await api.post(`/login`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data;
  },

  forgot_password: async (email) => {
    const response = await api.post(`/forgot-password`, { email });
    return response?.data;
  },

  reset_password: async ({ token, email, new_password }) => {
    const response = await api.post(`/reset-password`, {
      token,
      email,
      new_password,
    });

    return response?.data;
  },

  logout: async () => {
    const response = await api.post(`logout`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data;
  },
};
